import { render } from "./AffinityGroupSelection.vue?vue&type=template&id=6883e654&scoped=true"
import script from "./AffinityGroupSelection.vue?vue&type=script&lang=js"
export * from "./AffinityGroupSelection.vue?vue&type=script&lang=js"

import "./AffinityGroupSelection.vue?vue&type=style&index=0&id=6883e654&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6883e654"]])

export default __exports__